import { useTranslations } from 'next-intl';

export default function OrdersTableSortingBar() {
    const t = useTranslations('Common');
    return (
        <div className="flex items-center border-b border-white/50 pb-5 gap-5 lg:justify-between max-lg:overflow-auto max-lg:w-fit text-[14px] lg:text-md font-helvetica-neue text-gray-200">
            {/* <SortButton
                className="max-w-[150px] min-w-[150px] w-full flex items-center"
                name="Date"
            /> */}
            <div className="max-w-[150px] min-w-[150px] w-full flex items-center">{t('date')}</div>
            <div className="max-w-[250px] min-w-[250px] w-full flex items-center">{t('name')}</div>
            <div className="max-w-[200px] min-w-[200px] w-full flex items-center">{t('type')}</div>
            <div className="max-w-[100px] min-w-[100px] w-full flex items-center">
                {t('quantity')}
            </div>
            <div className="max-w-[100px] min-w-[100px] w-full flex items-center">{t('price')}</div>
            <div className="max-w-[100px] min-w-[100px] w-full text-white"></div>
        </div>
    );
}
